import "./challenge.css";

export default function ChallengeBanner({ info, compact = false }) {
  if (!info?.is_challenge_day) return null;

  return (
    <div
      className={`challenge-banner ${compact ? "px-5 py-3" : "px-6 py-5"} flex items-center gap-5`}
      data-testid="challenge-banner"
    >
      <div className="relative z-10 flex items-center gap-3">
        <div className="font-anton text-4xl leading-none animate-pulse">⚠</div>
      </div>
      <div className="relative z-10 flex-1 min-w-0">
        <div className="label-mono" style={{ color: "var(--stakes-admin)", opacity: 0.85 }}>
          BONUS CHALLENGE DAY
        </div>
        <div className={`font-anton uppercase leading-none mt-1 ${compact ? "text-2xl" : "text-3xl lg:text-4xl"}`}>
          Today is a Bonus Challenge Day!
        </div>
        <div className={`font-barlow uppercase font-bold mt-1 ${compact ? "text-base" : "text-lg"}`}>
          Earn <span className="challenge-chip px-2 py-0.5">+30</span> per task ·{" "}
          <span className="challenge-chip px-2 py-0.5">0</span> penalty for misses
        </div>
      </div>
      <div className="relative z-10 hidden md:block font-anton text-4xl leading-none animate-pulse">⚠</div>
    </div>
  );
}
